import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { setRouterHistory } from "../service/Navigation";
import { useModal } from "../context/ModalContext";

/**
 * Router içinde bir kez render edilir (HisRouter):
 * - geçmiş nesnesini Navigation servisine kaydeder (modal içinden navigate() çalışsın),
 * - sayfa (pathname) değişince açık modalları kapatır. Tam yüklemede modallar zaten yok oluyordu;
 *   SPA geçişinde eski sayfanın önizleme modalı yeni sayfanın üstünde kalmasın.
 *   Yalnız pathname'e bakılır: grid'lerin ?filter= güncellemesi modalı kapatmaz.
 */
export default function NavigationBridge() {
    const history = useHistory()
    const location = useLocation()
    const { closeAllModals } = useModal()
    const prevPathname = useRef(location.pathname)

    // Render sırasında kaydedilir: çocukların ilk effect'lerinde navigate() hazır olsun.
    setRouterHistory(history)

    useEffect(() => {
        if (prevPathname.current !== location.pathname) {
            prevPathname.current = location.pathname
            closeAllModals()
        }
    }, [location.pathname])

    return null
}
